const initState = {
  authError: null,
};

const authReducers = (state = initState, action) => {
  switch (action.type) {
    case "ADMIN_SIGNUP_SUCCESS":
      return {
        ...state,
        authError: null,
      };
    case "ADMIN_SIGNUP_ERROR":
      return {
        ...state,
        authError: action.error,
      };
    case "ADMIN_SIGNIN_SUCCESS":
      return {
        ...state,
        authError: null,
      };
    case "ADMIN_SIGNIN_ERROR":
      return {
        ...state,
        authError: action.error,
      };
    case "ADMIN_SIGNOUT__SUCCESS":
      return {
        ...state,
        authError: null,
      };
    default:
      return state;
  }
};

export default authReducers;
